export default __webpack_public_path__ + "static/media/1120.37f8dca2.png";